import React from 'react';
import './PersonalTests.scss';
import MainLayout from '../../components/TheMainLayout/MainLayout';
import { Switch, Route } from 'react-router-dom';
import PersonalTestsCity from './PersonalTestsCity';
import PersonalTestsDetail from './PersonalTestsDetail';
import { routesURLs } from '../../Routes';

const PersonalTests = () => {
    return (
        <MainLayout>
            <Switch>
                <Route
                    path={`${routesURLs.personalTests}/:id`}
                    exact={true}
                    render={(props) => <PersonalTestsDetail {...props} />}
                />
                <Route path={routesURLs.personalTests} exact={true} render={(props) => <PersonalTestsCity {...props} />} />
            </Switch>
        </MainLayout>
    );
};

export default PersonalTests;
